import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from '@Sage/hoi-poi-ui';
import AddOnsCard from './components/AddOnsCard';

import styles from './styles/AddOns';
const useStyles = createUseStyles(styles, 'AddOns');

const AddOns = memo(({ onHover, schema, linkCallback }) => {
    const classes = useStyles();

    const cards = useMemo(() => {
        return schema?.length
            ? schema.map((card, index) => (
                  <AddOnsCard key={index} onHover={onHover} linkCallback={linkCallback} {...card} />
              ))
            : [];
    }, [schema, onHover, linkCallback]);

    return cards.length ? <section className={classes.root}>{cards}</section> : null;
});

AddOns.propTypes = {
    onHover: PropTypes.func,
    schema: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            icon: PropTypes.string,
            badge: PropTypes.shape({
                text: PropTypes.string,
                type: PropTypes.oneOf(['success', 'info', 'promotion']),
            }),
            content: PropTypes.shape({
                price: PropTypes.string,
                priceInfo: PropTypes.string,
                description: PropTypes.string,
            }),
            figure: PropTypes.shape({
                img: PropTypes.func,
                caption: PropTypes.string,
            }),
            info: PropTypes.shape({
                text: PropTypes.arrayOf(PropTypes.string),
                cta: PropTypes.arrayOf(
                    PropTypes.shape({
                        type: PropTypes.oneOf(['primary', 'secondary']),
                        text: PropTypes.string,
                        onClick: PropTypes.func,
                    }),
                ),
            }),
        }),
    ).isRequired,
    linkCallback: PropTypes.func,
};

export default AddOns;
